export interface PlanLimits {
  isEnterprise: boolean;
  isPro: boolean;
  limite: number;
  label: string;
}

export const getPlanLimits = (planoNome: string | null): PlanLimits => {
  const nomeLower = (planoNome || "").toLowerCase().trim();
  const isEnterprise = nomeLower.includes("enterprise");
  const isPro = nomeLower.includes("pro") && !isEnterprise;

  let limite = -1;
  let label = "Enterprise";

  if (isEnterprise) {
    limite = -1;
    label = "Enterprise";
  } else if (isPro) {
    limite = 10;
    label = "Agenda Pro";
  } else {
    limite = 5;
    label = "Light";
  }

  return { isEnterprise, isPro, limite, label };
};
